// extracted by mini-css-extract-plugin
export default {"body":"quickLinks_body__qfz0V","linkStyle":"quickLinks_linkStyle__XB2X9"};